import { getCartOrLineItemGtagData, getProductGtagData } from './helpers';
import { BundledPotProductAndVariantInfo, MainProductAndVariantInfo } from './types';
import CartItem from '../component/cart/CartItem';

export const logAddProductToCartEvent = (
  mainProductVariantInfo: MainProductAndVariantInfo,
  bundledPotVariant?: BundledPotProductAndVariantInfo,
): void => {
  const dataLayerViewEvent = {
    event: 'add_to_cart',
    ecommerce: {
      items: getProductGtagData(mainProductVariantInfo, bundledPotVariant),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logViewCartEvent = (items: CartItem[]): void => {
  const dataLayerViewEvent = {
    event: 'view_cart',
    ecommerce: {
      items: items.map((item, index) => ({
        ...getCartOrLineItemGtagData(item, CartJS.cart.items[index].quantity),
        index: index + 1,
      })),
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};

export const logRemoveProductFromCartEvent = (
  item: CartItem,
  itemIndex: number,
  quantity?: number,
): void => {
  const dataLayerViewEvent = {
    event: 'remove_from_cart',
    ecommerce: {
      items: [{
        ...getCartOrLineItemGtagData(item, quantity || CartJS.cart.items[itemIndex].quantity),
        index: itemIndex + 1,
      }],
    },
  };

  global.dataLayer.push({ ecommerce: null });
  global.dataLayer.push(dataLayerViewEvent);
};
